import React, { Component, Fragment } from 'react';
import { InView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import SubHead from '../SubHead/SubHead';
import MiniHed from '../SubHead/MiniHed';
import BodyText from '../BodyText/BodyText';
import Button from '../../../common/Button';
import { isValid, isText, decodeTags, sendLog } from '../../../../utils';
import "./embed-module.scss";

class VideoEmbed extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.processEmbed = this.processEmbed.bind(this);
    this.processJWPlayer = this.processJWPlayer.bind(this);
    this.embed = null;
    this.isJW = false;
  }

  

  processEmbed(embed) {
    const encodedData = decodeTags(embed);
    return encodedData;
  }

  processJWPlayer(embed) {
    const dom = document.createElement('div');
    dom.innerHTML = embed;
    const src = dom.childNodes[0].getAttribute('src');
    const ids = src.replace('https://cdn.jwplayer.com/players/', '').replace('.js', '').replace('-', '_');
    const playerDivId = `botr_${ids}_div`;
    const playerDiv = document.createElement('div');
    playerDiv.id = playerDivId;
    document.getElementById('jwPlayer').appendChild(playerDiv);
    const script = document.createElement('script');
    script.src = src;
    document.getElementById('jwPlayer').appendChild(script);
  }

  componentDidMount() {
    if(this.isJW) {
      const embed = this.processEmbed(this.embed);
      try {    
        this.processJWPlayer(embed);
      } catch(e) {
        
      }
    }
  }

  componentDidUpdate() {
    if(this.isJW) {
      const embed = this.processEmbed(this.embed);
      try {    
        this.processJWPlayer(embed);
      } catch(e) {
        
      }
    }
  }

  render() {
    const { mounted } = this.state;
    const { data, articleLayout, isAffiliate, isMobile, isClient } = this.props;
    if (!isValid(data)) { return null; }
    let { className } = this.props;
    const { hed=null, hedBody=null, subhed=null, bodyText=null, hedPlacement=null, videoEmbedLayout="default"} = data;
    
    className = className + " " + videoEmbedLayout;

    if (!isValid(data.jwplayer) && !isValid(data.embed)) {
      return null;
    }

    const jwplayer = isValid(data.jwplayer) ? data.jwplayer : null;
    const embed = isValid(data.embed) ? data.embed : jwplayer;
    const isJW = (embed === jwplayer);
    this.embed = embed;
    this.isJW = isJW;

    const encodedData = (embed !== null) ? this.processEmbed(embed) : '';
    const { buttonText, buttonUrl } = data;
    const isYoutube = embed.includes('www.youtube.com');
    className = `${className} ${isYoutube ? 'youtube' : ''}`;
    const button = (isText(buttonText) && isText(buttonUrl)) ? {text: buttonText, url: buttonUrl} : null;
    const renderedButton = button ? <Button button={button} /> : null;
    const renderedBodyText = bodyText ? <BodyText className="body-text" articleLayout={articleLayout} data={bodyText} isAffiliate={isAffiliate} hasBuyButton={true}/> : null;
     const rootMargin = `0% 0% ${isMobile ? '50%' : '25%'} 0%`;

    return (
        <Fragment>
          { hedPlacement !== "below" &&
            <Fragment>
              {hed && <SubHead className="subhead-video-embed" articleLayout={articleLayout} data={hed} />}
              {hedBody && <BodyText className="header-body" articleLayout={articleLayout} data={hedBody}/>}
            </Fragment>
          }
          <InView triggerOnce={isClient} rootMargin={rootMargin}>
            {({ inView, ref }) => (
              <div ref={ref}>
                { inView &&
                  <Fragment>
                  {!isJW ?
                    <div className={className} dangerouslySetInnerHTML={{ __html: encodedData }} />
                  :
                    <div className={className} id="jwPlayer"></div>
                  }
                  </Fragment>
                }
              </div>
            )}
          </InView>

          { hedPlacement === "below" &&
            <Fragment>
              {hed && <SubHead className="subhead-video-embed" articleLayout={articleLayout} data={hed} />}
              {hedBody && <BodyText className="header-body" articleLayout={articleLayout} data={hedBody} />}
            </Fragment>
          }
          {subhed && <MiniHed className="sub-head" articleLayout={articleLayout} data={subhed} />}
          {renderedBodyText}
          {renderedButton}
        </Fragment>
    );
  }
}

VideoEmbed.propTypes = {
  className: PropTypes.string,
};

export default VideoEmbed;
